/**
 * Maps lobster projection annual_results to the standard fisheryData format
 * used by KeyInsights and other fishery components.
 */
export interface LobsterAnnualResult {
  year?: number;
  revenue?: number;
  bait_consumption?: number;
  herring_price?: number;
  menhaden_price?: number;
  weighted_bait_price?: number;
  profit?: number;
  bait_cost?: number;
}

export interface LobsterFisheryDataRow {
  year: number;
  stock_id: number | null;
  stock_name: string;
  mean_ex_vessel: number;
  ex_vessel_uncertainty: number;
  landed_economic_impact: number;
  landed_economic_impact_uncertainty: number;
  missedEconomyValue: number;
  missedEconomyUncertainty: number;
  mean_uncaught_ex_vessel: number;
  uncaught_ex_vessel_uncertainty: number;
  meals_produced: number;
  meals_uncertainty: number;
  trade_deficit_contribution: number;
  trade_deficit_uncertainty: number;
  total_jobs_mean: number;
  total_jobs_uncertainty: number;
  harvesting_jobs_mean: number;
  processing_jobs_mean: number;
  distribution_jobs_mean: number;
  support_services_jobs_mean: number;
  induced_jobs_mean: number;
  mean_uncaught_acl: number;
  uncaught_acl_uncertainty: number;
  lobster_revenue: number;
  lobster_bait_consumption: number;
  lobster_herring_price: number;
  lobster_menhaden_price: number;
  lobster_weighted_bait_price: number;
  lobster_profit: number;
  lobster_bait_cost: number;
}

export function mapLobsterAnnualResultsToFisheryData(
  annualResults: LobsterAnnualResult[]
): LobsterFisheryDataRow[] {
  return annualResults.map((row) => ({
    year: row.year ?? 0,
    stock_id: null,
    stock_name: 'American Lobster',
    mean_ex_vessel: row.revenue ?? 0,
    ex_vessel_uncertainty: 0,
    landed_economic_impact: 0,
    landed_economic_impact_uncertainty: 0,
    missedEconomyValue: 0,
    missedEconomyUncertainty: 0,
    mean_uncaught_ex_vessel: 0,
    uncaught_ex_vessel_uncertainty: 0,
    meals_produced: 0,
    meals_uncertainty: 0,
    trade_deficit_contribution: 0,
    trade_deficit_uncertainty: 0,
    total_jobs_mean: 0,
    total_jobs_uncertainty: 0,
    harvesting_jobs_mean: 0,
    processing_jobs_mean: 0,
    distribution_jobs_mean: 0,
    support_services_jobs_mean: 0,
    induced_jobs_mean: 0,
    mean_uncaught_acl: 0,
    uncaught_acl_uncertainty: 0,
    lobster_revenue: row.revenue ?? 0,
    lobster_bait_consumption: row.bait_consumption ?? 0,
    lobster_herring_price: row.herring_price ?? 0,
    lobster_menhaden_price: row.menhaden_price ?? 0,
    lobster_weighted_bait_price: row.weighted_bait_price ?? 0,
    lobster_profit: row.profit ?? 0,
    lobster_bait_cost: row.bait_cost ?? 0,
  }));
}
